import { Location } from '@angular/common';
import { AfterViewInit, Component, Injector, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { GridComponent } from '@progress/kendo-angular-grid';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CommonConstants } from 'src/app-core/constants/common-constants';
import { CommonService } from 'src/app-core/services/common.service';
import { CommonMethod } from 'src/app-core/methods/common-methods';
import { QuotesService } from 'src/app/quotes/quotes.service';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { DocumentTypeIdsEnum } from '../app-common-enum';
import { CommonDataModel } from '../common-data-model';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { OrderEmailPopupFormComponent } from '../order-email-popup-form/order-email-popup-form.component';
import { OrderPreviewDialogComponent } from '../order-preview-dialog/order-preview-dialog.component';
import { OrdersFreightShopperListComponent } from '../orders-freight-shopper-list/orders-freight-shopper-list.component';

const hasClass = (el, className) => new RegExp(className).test(el.className);
const isChildOf = (el, className) => {
    while (el && el.parentElement) {
        if (hasClass(el.parentElement, className)) {
            return true;
        }
        el = el.parentElement;
    }
    return false;
};

@Component({
    selector: 'app-orders-final-dims-routing',
    templateUrl: './orders-final-dims-routing.component.html',
    styleUrls: ['./orders-final-dims-routing.component.scss']
})
export class OrdersFinalDimsRoutingComponent extends AppComponentBase implements OnInit, AfterViewInit {

    @ViewChild('bolGrid', { static: false }) public bolGrid: GridComponent;
    @ViewChild('grid', { static: true }) public grid: GridComponent;
    @ViewChild('orderFinalDimsForm', { static: true }) orderFinalDimsForm: NgForm;
    @ViewChild('OrdersFreightShopperListComponent', { static: false }) OrdersFreightShopperListComponent: OrdersFreightShopperListComponent;
    @ViewChild(TooltipDirective, { static: true }) public tooltipDir: TooltipDirective;

    commonDataModel = new CommonDataModel();
    finalDimsRoutingFormData = this.commonDataModel.ordersFinalDimsRoutingModel;
    proNumberDataModel = _.cloneDeep(this.commonDataModel.proNumberDataModel);
    proBtnDisable = true;
    isFormLoading = false;
    isShowFreightShopper = false;
    isFinalBol = false;
    isFinalDimsSaved = false;
    orderId: string;
    carrierItemList: any;
    freightShipmentData: any = {
        data: [],
        total: 0
    };
    defaultCarrierItem = { carrierName: 'Select', carrierId: null };
    gridItems: any = {
        data: [],
        total: 0
    };
    shipmentGridItems: any = {
        data: [],
        total: 0
    };
    editedRowIndex: number;
    documentConfigs: any;
    finalDimsGetResponse: any;
    todayDate = new Date();
    shippingInfo = this.commonDataModel.ordersFinalDimsShippingDetailsModel;
    containers: any;
    finalDimsRoutingDataForRates: any;
    viewDocumentData = this.commonDataModel.bolFormModel;
    documentTypeEnum: typeof DocumentTypeIdsEnum = DocumentTypeIdsEnum;
    orderDetails: any;
    dummyResponse: any;
    orderPreviewData: any;
    ordersFrom: any;
    ordersTo: any;
    isAutoFetchFinalDimsText = '';
    isCellEdited = false;
    documents: any;
    classList = this.commonDataModel.getCommonCarrierClass;
    pkgList: any;
    isFV: boolean;
    minOperationStartTime: any;
    minDate = moment().format();
    minOperationEndTime: any;
    defaultStartTime: any = moment().set({ hour: 8, minute: 0, second: 0, millisecond: 0 }).format();
    defaultEndTime: any = moment().set({ hour: 17, minute: 0, second: 0, millisecond: 0 }).format();
    originalBolGrid = [];
    isClassModified = false;
    isEditEnable = false;
    isPkgTypeSaved = true;
    isClassSaved = true;
    isQuote: boolean = false;

    constructor(
        injector: Injector,
        private location: Location,
        private commonService: CommonService,
        private commonMethod: CommonMethod,
        private activatedRoute: ActivatedRoute,
        private toastr: ToastrService,
        private renderer: Renderer2,
        private dialog: MatDialog,
        private router: Router,
        private quotesService: QuotesService,
    ) {
        super(injector);
        this.renderer.listen(
            'document',
            'click',
            ({ target }) => {
                if (!isChildOf(target, 'finalDimsGrid')) {
                    if (this.orderFinalDimsForm.valid && this.editedRowIndex) {
                        this.bolGrid.closeRow(this.editedRowIndex);
                        this.editedRowIndex = null;
                    }
                }
            });
    }

    ngOnInit() {
        this.isFV = this.commonService.getTenentIsFreightViewIntegrated();
        this.orderPreviewData = { proNumber: '' };
        this.onLoadItems();
        this.shipmentGridItems.total = 0;
        this.onGetOrderDetailsAccount();
        this.getInitialDataForFreightShopper();
        this.onLoadPackageTypes();
    }

    ngAfterViewInit() {
        this.expandRows();
    }

    onLoadPackageTypes() {
        this.commonService.getPackageType().subscribe(response => {
            if (response.isSuccess) {
                this.pkgList = response.data;
            }
        });
    }

    onLoadItems() {
        if (this.activatedRoute.snapshot.queryParams.jobId) {
            this.orderId = this.activatedRoute.snapshot.queryParams.jobId;
        } else {
            this.orderId = this.activatedRoute.snapshot.queryParams.quoteId;
        }
        this.getDocumentConfigs();
        this.getFinalDims();
        this.proBtnDisable = true;
        this.isQuote = this.router.url.includes("quotes/quote-details");
    }

    expandRows() {
        this.commonMethod.expandRows(this.bolGrid);
    }

    onCalculateVolume(dataItem) {
        return this.commonMethod.calculateVolume(dataItem);
    }

    onCalculateTotalWeight(dataItem) {
        return this.commonMethod.calculateTotalWeight(dataItem);
    }

    getFreightClass(density: number): string {
        return this.commonMethod.getFreightClass(density);
    }

    onAddProNumber() {
        this.isFormLoading = true;
        this.proNumberDataModel.pro = this.orderPreviewData.proNumber
        this.proNumberDataModel.orderId = this.orderId;
        this.commonService.saveProNumber(this.proNumberDataModel)
            .pipe(finalize(() => (this.isFormLoading = false)))
            .subscribe((response: any) => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.toastr.success(response.errors);
                    this.proBtnDisable = true;
                }
            });
    }

    onProNumberChange() {
        this.proBtnDisable = false;
    }

    getCarriersList() {
        const queryString = `CarrierId=${this.finalDimsRoutingFormData.carrierId === null ? 0 : this.finalDimsRoutingFormData.carrierId}`;
        this.commonService.getCarriersList(queryString).subscribe((response: any) => {
            if (response.isSuccess) {
                this.carrierItemList = response.data;
            }
        });
    }

    getDocumentConfigs() {
        this.commonService.getDocumentConfig(this.orderId, 4).subscribe(response => {
            if (response.isSuccess) {
                this.documentConfigs = _.cloneDeep(response.data);
            }
        });
    }

    getFinalDims(): void {
        this.isFormLoading = true;
        this.isPkgTypeSaved = true;
        this.isClassSaved = true;
        this.gridItems.data = [];
        const query = `?OrderId=${this.orderId}`;
        this.commonService.getFinalDimsRouting(query)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.isAutoFetchFinalDimsText = response.data.isAutoFetchFinalDims ? CommonConstants.finalDimsRoutingComponent.jobDims : CommonConstants.finalDimsRoutingComponent.finalDims;
                    response.data.shippingCost = response.data.shippingCost ? response.data.shippingCost.toFixed(2) : 0;
                    this.finalDimsGetResponse = _.cloneDeep(response.data);
                    this.finalDimsRoutingFormData = Object.assign(this.finalDimsRoutingFormData, response.data);
                    this.finalDimsRoutingFormData.trackingNumber = response.data.shipmentId ? response.data.shipmentId : response.data.trackingNumber ? response.data.trackingNumber : '';
                    this.orderPreviewData.proNumber = this.finalDimsRoutingFormData.pro;
                    this.getCarriersList();
                    if (response.data.getFinalBol) {
                        this.isFinalBol = true;
                        this.gridItems.total = this.gridItems.data.length;
                        this.gridItems.data = response.data.getFinalBol;
                        this.shipmentGridItems.data = response.data.getFinalBol;
                        this.originalBolGrid = _.cloneDeep(response.data.getFinalBol);
                        this.originalBolGrid.map(val => {
                            if (!val.packageType) {
                                this.isPkgTypeSaved = false;
                            }
                            if (!val.freightClass) {
                                this.isClassSaved = false;
                            }
                        });
                        this.isFinalDimsSaved = response.data.isFinalDimsSaved;
                    } else {
                        this.isFinalBol = false;
                    }
                    this.shippingInfo.shippingFrom = response.data.shipper;
                    this.shippingInfo.shippingTo = response.data.consignee;
                    this.finalDimsRoutingDataForRates = this.finalDimsGetResponse;
                } else {
                    this.toastr.error(
                        response.errors || CommonConstants.appComponent.somethingWenWrongPleaseReTry, CommonConstants.appComponent.error);
                }
            });
    }

    getNewBOL(): any {
        const itemModel = Object.assign({}, this.commonDataModel.ordersFinalDimsBOLModel);
        const sortOrderMax = this.gridItems.data.reduce((op, item) => op = op > item.sortOrder ? op : item.sortOrder, 0);
        itemModel.sortOrder = sortOrderMax + 1;
        return itemModel;
    }

    onAddBOL(grid: any) {
        grid.editRow(0);
        this.gridItems.data.splice(0, 0, this.getNewBOL());
        this.gridItems.total = this.gridItems.data.length;
    }

    onRemoveBOL(index: any) {
        this.openConfirmationPopupRemoveBOL(index);
        // this.gridItems.data.splice(index, 1);
        // this.orderFinalDimsForm.form.markAsDirty();        
    }

    onCellClickHandler({ sender, rowIndex }, grid: any) {
        grid.closeRow(this.editedRowIndex);
        this.editedRowIndex = rowIndex;
        sender.editRow(rowIndex);
    }

    onCellEdited(dataItem?: any, column?: any, grid?: GridComponent) {
        if (this.finalDimsRoutingFormData.isAutoFetchFinalDims) {
            this.openConfirmationPopup(dataItem, column, grid);
        } else {
            this.editBolGrid(dataItem, column);
        }
    }

    openConfirmationPopup(dataItem?: any, column?: any, grid?: GridComponent) {
        this.dialog.open(ConfirmDialogComponent, {
            panelClass: 'confirm_layout',
            hasBackdrop: false,
            data: {
                message: CommonConstants.finalDimsRoutingComponent.jobDimsChangedToFinalDims,
                isShowTitle: true
            }
        }).afterClosed()
            .subscribe((response: any) => {
                if (response && response.confirmResult) {
                    this.isEditEnable = true;
                    this.editBolGrid(dataItem, column);
                } else {
                    grid.closeRow(this.editedRowIndex);
                    this.editedRowIndex = undefined;
                    this.isEditEnable = false;
                    this.getFinalDims();
                }
            });
    }

    openConfirmationPopupRemoveBOL(index: any) {
        this.dialog.open(ConfirmDialogComponent, {
            panelClass: 'confirm_layout',
            hasBackdrop: false,
            data: {
                message: CommonConstants.finalDimsRoutingComponent.jobDimsChangedToFinalDims,
                isShowTitle: true
            }
        }).afterClosed()
            .subscribe((response: any) => {
                if (response && response.confirmResult) {
                    this.isEditEnable = true;
                    this.gridItems.data.splice(index, 1);
                    this.orderFinalDimsForm.form.markAsDirty();
                    this.editBolGrid(null, '');
                } else {
                    this.editedRowIndex = undefined;
                    this.isEditEnable = false;
                    this.getFinalDims();
                }
            });
    }

    editBolGrid(dataItem?: any, column?: any) {
        this.isCellEdited = true;
        switch (column) {
            case CommonConstants.dimensionsConstants.quantity:
                dataItem.quantity = Math.ceil(dataItem.quantity);
                dataItem.weight = Math.ceil(dataItem.quantity * dataItem.unitDimentionWeight);
                break;
            case CommonConstants.dimensionsConstants.unit:
                dataItem.unitDimentionWeight = Math.ceil(dataItem.unitDimentionWeight);
                dataItem.weight = Math.ceil(dataItem.quantity * dataItem.unitDimentionWeight);
                break;
            case CommonConstants.dimensionsConstants.total:
                dataItem.unitDimentionWeight = Math.ceil(Math.ceil(dataItem.weight) / dataItem.quantity);
                dataItem.weight = Math.ceil(dataItem.quantity * dataItem.unitDimentionWeight);
                break;
            case CommonConstants.dimensionsConstants.length:
                dataItem.length = Math.ceil(dataItem.length);
                break;
            case CommonConstants.dimensionsConstants.width:
                dataItem.width = Math.ceil(dataItem.width);
                break;
            case CommonConstants.dimensionsConstants.height:
                dataItem.height = Math.ceil(dataItem.height);
                break;
        }
        if (this.finalDimsRoutingFormData.isAutoFetchFinalDims) {
            this.finalDimsRoutingFormData.isAutoFetchFinalDims = false;
            this.onFinalDimsAutoFetchToggleChange(false, true);
        }
    }

    onSaveFinalDims() {
        let isDescriptionEmpty = false;
        this.isCellEdited = true;
        if (this.finalDimsRoutingFormData.isAutoFetchFinalDims && this.isClassModified) {
            this.finalDimsRoutingFormData.isAutoFetchFinalDims = false;
            this.onFinalDimsAutoFetchToggleChange(false, false);
        }
        if (!this.finalDimsRoutingFormData.currentQuote.id) {
            this.finalDimsRoutingFormData.currentQuote.id = 0;
        }
        this.finalDimsRoutingFormData.currentQuote.pickupDate = moment(this.finalDimsRoutingFormData.currentQuote.pickupDate).utcOffset(0, true).format();
        this.finalDimsRoutingFormData.currentQuote.shipFromReadyTime = this.convertTimeToTimeString(this.commonService.convertedDateTimeFormat(this.finalDimsRoutingFormData.currentQuote.shipFromReadyTime));
        this.finalDimsRoutingFormData.currentQuote.shipFromCloseTime = this.convertTimeToTimeString(this.commonService.convertedDateTimeFormat(this.finalDimsRoutingFormData.currentQuote.shipFromCloseTime));
        this.finalDimsRoutingFormData.currentQuote.shipToOpenTime = this.convertTimeToTimeString(this.commonService.convertedDateTimeFormat(this.finalDimsRoutingFormData.currentQuote.shipToOpenTime));
        this.finalDimsRoutingFormData.currentQuote.shipToCloseTime = this.convertTimeToTimeString(this.commonService.convertedDateTimeFormat(this.finalDimsRoutingFormData.currentQuote.shipToCloseTime));
        if (this.finalDimsRoutingFormData.carrierId && !this.finalDimsRoutingFormData.carrierName) {
            this.finalDimsRoutingFormData.carrierName = this.carrierItemList.find(carrier => carrier.id === this.finalDimsRoutingFormData.carrierId).carrierName;
            this.finalDimsRoutingFormData.carrierUrl = this.carrierItemList.find(carrier => carrier.id === this.finalDimsRoutingFormData.carrierId).carrierUrl;
        }
        this.finalDimsRoutingFormData.pro = this.orderPreviewData.proNumber;
        this.finalDimsRoutingFormData.items = this.gridItems.data;
        if (this.finalDimsRoutingFormData.items && this.finalDimsRoutingFormData.items.length > 0) {
            this.finalDimsRoutingFormData.items.find((value) => {
                if (!value.description) {
                    isDescriptionEmpty = true;
                }
            });
        }
        if (isDescriptionEmpty) {
            this.toastr.warning(CommonConstants.appComponent.descriptionValidationMessage);
            this.isFormLoading = false;
            this.finalDimsRoutingFormData.currentQuote.shipFromReadyTime = this.defaultStartTime;
            this.finalDimsRoutingFormData.currentQuote.shipFromCloseTime = this.defaultEndTime;
            this.finalDimsRoutingFormData.currentQuote.shipToOpenTime = this.defaultStartTime;
            this.finalDimsRoutingFormData.currentQuote.shipToCloseTime = this.defaultEndTime;
        } else {
            this.finalDimsRoutingFormData.orderId = this.orderId;
            this.finalDimsRoutingFormData.serviceDate = moment(this.todayDate).format();
            if (!this.finalDimsRoutingFormData.carrierId) {
                this.finalDimsRoutingFormData.carrierId = 0;
            }
            if (!this.finalDimsRoutingFormData.shippingCost) {
                this.finalDimsRoutingFormData.shippingCost = 0;
            }
            this.isFormLoading = true;
            if (this.isCellEdited && this.finalDimsRoutingFormData.isAutoFetchFinalDims) {
                this.finalDimsRoutingFormData.isAutoFetchFinalDims = false;
                this.onFinalDimsAutoFetchToggleChange(false, false);
            }
            this.commonService.createFinalDimsRouting(this.finalDimsRoutingFormData)
                .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                    this.isFormLoading = false;
                    this.orderFinalDimsForm.form.markAsPristine();
                    if (response.isSuccess) {
                        this.finalDimsRoutingFormData.isDataChange = false;
                        this.getFinalDims();
                        this.getInitialDataForFreightShopper();
                        this.toastr.success(response.errors);
                        this.updateOrderHeaders();
                    } else {
                        this.toastr.error(
                            response.errors || CommonConstants.appComponent.somethingWenWrongPleaseReTry, CommonConstants.appComponent.error);
                    }
                });
        }
    }

    onCarrierChange(event: any) {
        this.finalDimsRoutingFormData.carrierName = event.carrierName;
        this.finalDimsRoutingFormData.carrierUrl = event.carrierUrl ? event.carrierUrl : null;
        this.OrdersFreightShopperListComponent.getQuoteRequest.carriers = [{
            id: event.id,
            carrierName: event.carrierName
        }];
    }

    onEmailBOL() {
        const dataItem = _.find(this.documents, { name: CommonConstants.bolFreightView });
        this.dialog.open(OrderEmailPopupFormComponent, {
            position: {
                right: '0',
            },
            panelClass: 'small_layout',
            hasBackdrop: false,
            autoFocus: false,
            data: {
                documentConfigData: this.documentConfigs,
                orderId: this.orderId,
                documentDetails: {},
                source: 'finalDims',
                orderDetails: this.finalDimsGetResponse,
                fvBolUrl: dataItem ? dataItem.pdfUrl : '',
                bolUrl: dataItem ? dataItem.blobUrl : '',
                isFv: true
            },
        }).afterClosed()
            .subscribe((response: { confirmResult: boolean }) => {
                if (response && response.confirmResult === true) {
                }
            });
    }

    emitFreightSopperDetails(data: any): void {
        this.commonService.objectMapping(this.finalDimsRoutingFormData, data);
        this.finalDimsRoutingFormData.serviceName = data.serviceTypeName;
        if (this.isFV) {
            this.getInitialDataForFreightShopper();
            this.getFinalDims();
        }
        this.orderFinalDimsForm.form.markAsDirty();
    }

    onViewBOL() {
        this.viewDocumentData.orderId = this.orderId;
        this.viewDocumentData.emailDetails.to = this.documentConfigs.shipFromEmail ? this.documentConfigs.shipFromEmail : (this.documentConfigs.shipToEmail ? this.documentConfigs.shipToEmail :
            (this.documentConfigs.payerEmail ? this.documentConfigs.payerEmail : (this.documentConfigs.intermediateEmail ? this.documentConfigs.intermediateEmail : '')));
        this.viewDocumentData.emailDetails.cc = this.documentConfigs.cc;
        this.viewDocumentData.emailDetails.bcc = this.documentConfigs.bcc;
        this.viewDocumentData.emailDetails.subject = this.documentConfigs.subject;
        this.viewDocumentData.emailDetails.body = this.documentConfigs.body;
        this.isFormLoading = true;
        this.commonService.bolViewDocument(this.viewDocumentData)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                const data: any = response;
                this.commonService.viewBolbFile(data.body as any, { type: data.body.type }, ``);
            });
    }

    onBack() {
        if (this.orderFinalDimsForm.form.dirty && this.isEditEnable) {
            this.commonService.getConfirmationPopup(CommonConstants.finalDimsRoutingComponent.discardTheChanges)
                .then(result => {
                    if (result) {
                        this.location.back();
                    }
                });
        } else {
            if (this.router.url.includes('quotes')) {
                this.router.navigateByUrl(`app/quotes/quote-details?quoteId=${this.orderId}`);
            } else {
                this.router.navigateByUrl(`app/jobs/job-details?jobId=${this.orderId}`);
            }
        }
    }

    onOrderPreview() {
        if (this.orderPreviewData.currentQuote.isDataChanged) {
            this.toastr.warning(CommonConstants.finalDimsRoutingComponent.pleaseReQuote, null, { timeOut: 5000 });
            return;
        }
        if (!this.orderDetails.payer || this.orderDetails.payer.isQuickContact) {
            this.toastr.warning(CommonConstants.finalDimsRoutingComponent.pleaseAddBillToInformation, null, { timeOut: 5000 });
            return;
        }
        this.dialog.open(OrderPreviewDialogComponent, {
            position: {
                right: '0',
            },
            panelClass: ['center_layout', 'full_min_height'],
            hasBackdrop: false,
            data: {
                contactId: null,
                isEdit: false,
                accountId: 1111,
                accountName: 'account name',
                orderId: this.orderId
            },
            autoFocus: false
        }).afterClosed()
            .subscribe((response: any) => {
                if (response && response.confirmResult === true) {
                    this.onLoadItems();
                    this.onGetOrderDetailsAccount();
                    this.getInitialDataForFreightShopper();
                }
            });
    }

    onGetOrderDetailsAccount(): void {
        this.isFormLoading = true;
        this.quotesService.getQuote(this.orderId)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.orderDetails = response.data;
                }
            });
    }

    copyId() {
        if (this.orderDetails.displayId) {
            this.finalDimsRoutingFormData.originReferenceNumber = this.orderDetails.displayId;
            this.orderFinalDimsForm.form.markAsDirty();
        }
    }

    getInitialDataForFreightShopper() {
        const payload = {
            id: this.orderId
        };
        this.commonService.getDataForFreightShopper(payload).subscribe((response: any) => {
            if (response.isSuccess) {
                const proNumber = this.orderPreviewData.proNumber;
                this.orderPreviewData = response.data;
                this.orderPreviewData.proNumber = proNumber;

                this.ordersFrom = this.orderPreviewData.shipper;
                this.ordersTo = this.orderPreviewData.consignee;
                this.finalDimsRoutingFormData.trackingNumber = this.orderPreviewData.shipmentId ? this.orderPreviewData.shipmentId : this.finalDimsRoutingFormData.trackingNumber;
                if (this.orderPreviewData.currentQuote) {
                    this.finalDimsRoutingFormData.currentQuote.id = response.data.currentQuote ? response.data.currentQuote.id ? response.data.currentQuote.id : null : null;
                    this.finalDimsRoutingFormData.currentQuote.pickupDate = response.data.currentQuote ? response.data.currentQuote.pickupDate ? response.data.currentQuote.pickupDate : new Date() : new Date();
                    this.finalDimsRoutingFormData.currentQuote.shipFromReadyTime = response.data.currentQuote ? response.data.currentQuote.shipFromReadyTime ? moment(response.data.currentQuote.shipFromReadyTime, ['h:m a', 'H:m']).format() : this.defaultStartTime : this.defaultStartTime;
                    this.finalDimsRoutingFormData.currentQuote.shipFromCloseTime = response.data.currentQuote ? response.data.currentQuote.shipFromCloseTime ? moment(response.data.currentQuote.shipFromCloseTime, ['h:m a', 'H:m']).format() : this.defaultEndTime : this.defaultEndTime;
                    this.finalDimsRoutingFormData.currentQuote.shipToOpenTime = response.data.currentQuote ? response.data.currentQuote.shipToOpenTime ? moment(response.data.currentQuote.shipToOpenTime, ['h:m a', 'H:m']).format() : this.defaultStartTime : this.defaultStartTime;
                    this.finalDimsRoutingFormData.currentQuote.shipToCloseTime = response.data.currentQuote ? response.data.currentQuote.shipToCloseTime ? moment(response.data.currentQuote.shipToCloseTime, ['h:m a', 'H:m']).format() : this.defaultEndTime : this.defaultEndTime;
                } else {
                    this.finalDimsRoutingFormData.currentQuote = this.commonDataModel.ordersFinalDimsRoutingModel.currentQuote;
                    this.finalDimsRoutingFormData.currentQuote.pickupDate = new Date();
                    this.finalDimsRoutingFormData.currentQuote.shipFromReadyTime = this.defaultStartTime;
                    this.finalDimsRoutingFormData.currentQuote.shipFromCloseTime = this.defaultEndTime;
                    this.finalDimsRoutingFormData.currentQuote.shipToOpenTime = this.defaultStartTime;
                    this.finalDimsRoutingFormData.currentQuote.shipToCloseTime = this.defaultEndTime;
                }
            }
        });
    }

    onFinalDimsAutoFetchToggleChange(isAutoFetch: any, isDimensionChange: any) {
        this.finalDimsRoutingFormData.isDataChange = true;
        this.isAutoFetchFinalDimsText = isAutoFetch ? CommonConstants.finalDimsRoutingComponent.jobDims : CommonConstants.finalDimsRoutingComponent.finalDims;
        const payload = {
            orderId: this.orderId,
            isAutoFetchFinalDims: isAutoFetch
        };
        this.commonService.changeIsAutoFetchFinalDims(payload).subscribe((response: any) => {
            if (response.isSuccess) {
                this.toastr.success(response.errors || CommonConstants.appComponent.savedSuccessfully);
                if (!isDimensionChange) {
                    this.isCellEdited = false;
                    this.getFinalDims();
                }
            }
        });
    }

    onShowTooltip(e: any): void {
        if (this.tooltipDir) {
            if (e.target.offsetWidth < e.target.scrollWidth) {
                this.tooltipDir.toggle({ nativeElement: e.target });
            } else {
                this.tooltipDir.hide();
            }
        }
    }

    receiveDocuments($event) {
        this.documents = $event.items;
    }

    onBolFreightView() {
        if (this.documents) {
            const dataItem = _.find(this.documents, { name: CommonConstants.bolFreightView });
            if (dataItem) {
                window.open(dataItem.blobUrl, '_blank');
            } else {
                this.toastr.info(CommonConstants.documentConstants.documentNotAvailable);
            }
        }
    }

    emitSelectedAccessorials(data: any) {
        if (data) {
            this.finalDimsRoutingFormData.ancillariesDetails = data;
        }
    }

    onClassChange(event: any, dataItem: any, grid: GridComponent) {
        if (this.isClassSaved && dataItem.freightClass && !this.isEditEnable && this.finalDimsRoutingFormData.isAutoFetchFinalDims) {
            this.isClassModified = true;
            this.openConfirmationPopup('', '', grid);
        }
        dataItem.freightClass = event.label;
        dataItem.nmfcValue = event.value;
    }

    onPkgChange(event: any, dataItem: any, grid: GridComponent) {
        if (event.name !== 'Select') {
            if (this.isPkgTypeSaved && dataItem.packageType && !this.isEditEnable && this.finalDimsRoutingFormData.isAutoFetchFinalDims) {
                this.openConfirmationPopup('', '', grid);
            }
            dataItem.packageType = event.name;
        }
    }

    onChangeDate(event: any) {
        this.finalDimsRoutingFormData.currentQuote.pickupDate = moment(event.value).format();
        if ((new Date(this.finalDimsRoutingFormData.currentQuote.pickupDate) > (new Date(moment().format())))) {
            this.minOperationStartTime = null;
        } else {
            this.minOperationStartTime = moment().format();
        }
    }

    convertTimeToTimeString(time: any) {
        const exactTime = new Date(time);
        const hours = exactTime.getHours();
        const minutes = this.commonService.addZeroToMinutes(exactTime.getMinutes());
        const timeString = this.commonService.getExactHours(hours, minutes);
        return timeString;
    }

    disableWeekends = (d: Date): boolean => {
        const day = d.getDay();
        return day !== 0 && day !== 6;
    }

    updateOrderHeaders() {
        const queryString = `?OrderId=${this.orderId}`;
        this.commonService.getOrdersHeadersById(queryString).subscribe(response => {
            if (response.isSuccess) {
                response.data.amountPaid = (response.data.amountPaid) ? response.data.amountPaid.toFixed(2) : 0;
                this.quotesService.orderHeaderDetails = response.data;
                this.quotesService.updateOrderHeaderDetails.next(this.quotesService.orderHeaderDetails);
            }
        });
    }

}
